import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "room" }
const _hoisted_2 = { class: "room__header form-custom" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "bt-icon bt-icon--m" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "list-bubbles list-bubbles--xs ml-auto mr-3" }
const _hoisted_7 = { class: "bt-icon bt-icon--xs" }
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = { class: "room__objects list-unstyled" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "room__object-icon bt-icon bt-icon--s" }
const _hoisted_12 = { class: "room__object-title" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("small", null, "1", -1)
const _hoisted_15 = { class: "ml-1 bt-icon bt-icon--xs text-warning" }
const _hoisted_16 = { class: "confirmation-content" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_ElPopover = _resolveComponent("ElPopover")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("li", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, [
            (_ctx.room.type !== undefined)
              ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                  key: 0,
                  src: require(`@/assets/images/icons/${_ctx.getRoomIconFromType(_ctx.room.type)}.svg`)
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "plantname",
              modelValue: _ctx.room.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.room.name = $event)),
              class: "w-100 ml-3 text-uppercase",
              disabled: !_ctx.plantInlineRenameEnabled
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createVNode("div", {
          class: "spacer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToRoomDetail && _ctx.goToRoomDetail(...args)))
        }, "_"),
        _createVNode("div", _hoisted_6, [
          (_openBlock(), _createBlock("div", {
            key: _ctx.roomObjectCount,
            class: "p-button p-button-rounded p-button-secondary fs-14 no-click"
          }, _toDisplayString(_ctx.roomObjectCount), 1))
        ]),
        _createVNode(_component_Button, {
          class: "apartment__action p-button-rounded p-button-outlined",
          onClick: _ctx.handleAddObject
        }, {
          default: _withCtx(() => [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_InlineSvgScoped, {
                src: 
                            require(`@/assets/images/icons/icon-plus-outline.svg`)
                        ,
                "aria-label": "icon-grid"
              }, null, 8, ["src"])
            ]),
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.AddAnObject")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-chevron-right",
          class: "p-button-text p-button-secondary ml-3",
          onClick: _ctx.goToRoomDetail
        }, null, 8, ["onClick"])
      ]),
      _createVNode("ul", _hoisted_9, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roomObjects, (object) => {
          return (_openBlock(), _createBlock("li", {
            key: object.type,
            class: "flex-column align-items-start"
          }, [
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require(`@/assets/images/icons/${object.icon}.svg`)
                            
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_12, _toDisplayString(object.count) + " " + _toDisplayString(object.name), 1)
            ]),
            false
              ? (_openBlock(), _createBlock("span", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_ElPopover, {
                    placement: "right",
                    trigger: "hover",
                    title: "Configuration to end",
                    "popper-class": "el-popover--dark  el-popover--slim"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode("span", _hoisted_15, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: 
                                        require(`@/assets/images/icons/icon-alert-hight-full.svg`)
                                    
                        }, null, 8, ["src"])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Dialog, {
      modal: true,
      visible: !_ctx.isValidName,
      style: { width: '350px' },
      closable: false,
      header: _ctx.$t('uniqueNaming.unavailableName')
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-primary p-button-rounded p-button--m",
          onClick: _ctx.onHideNameValidationDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Ok")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_16, [
          _createVNode("p", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.invalidNameReason) + " ", 1),
            _hoisted_18,
            _createVNode("sub", null, _toDisplayString(_ctx.$t("uniqueNaming.nameResetDisclaimer")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}